import { Component, EventEmitter, Input, Output } from "@angular/core";
import { SampleBoardItem, SampleBoardItemStatus } from "@app/strain/sample-boards/models/sample-board-item.model";

type StockFilter = 'all' | 'available' | 'validation';

@Component({
    selector: 'app-sample-board-stoc-list',
    templateUrl: './sample-board-stoc-list.component.html',
    styleUrls: ['./sample-board-stoc-list.component.scss']
})
export class SampleBoardStocListComponent {
    @Input() items: SampleBoardItem[] = [];
    @Input() isLoading = false;
    @Input() isSaving = false;
    @Output() editStock = new EventEmitter<void>();

    activeFilter: StockFilter = 'all';
    tabs: { label: string; link: StockFilter; active: boolean }[] = [
        { label: 'generic.all', link: 'all', active: true },
        { label: 'admin.strain.sample-boards.details.tabs.stoc.available', link: 'available', active: false },
        { label: 'admin.strain.sample-boards.details.tabs.stoc.validation', link: 'validation', active: false }
    ];

    get filteredItems(): SampleBoardItem[] {
        if (this.activeFilter === 'available') {
            return (this.items || []).filter(it => it.status === SampleBoardItemStatus.AvailableInStock);
        }
        if (this.activeFilter === 'validation') {
            return (this.items || []).filter(it => it.status !== SampleBoardItemStatus.AvailableInStock);
        }
        return this.items || [];
    }

    setFilter(filter: StockFilter): void {
        this.activeFilter = filter;
        this.tabs = this.tabs.map(tab => ({ ...tab, active: tab.link === filter }));
    }

    onTabsChange(tabs: { label: string; link: StockFilter; active: boolean }[]): void {
        const active = tabs.find(tab => tab.active);
        if (active) {
            this.setFilter(active.link);
        }
    }

    onEditStockClick(): void {
        if (this.isLoading || this.isSaving) {
            return;
        }
        this.editStock.emit();
    }
}
